import DuiDesktopNotificationManager from './dui-desktop-notification-manager/dui-desktop-notification-manager';
import DuiNotificationManager from './dui-notification-manager/dui-notification-manager';
import DuiPageGuardManager from './dui-page-guard-manager/dui-page-guard-manager';
import DuiUniqueInstanceManager from './dui-unique-instance-manager/dui-unique-instance-manager';

export default [
  DuiDesktopNotificationManager,
  DuiNotificationManager,
  DuiPageGuardManager,
  DuiUniqueInstanceManager,
];
